export const MAX_PICTURE_SIZE = 4600000;
export const MAX_AUDIO_SIZE = 10048576;
